'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _currentlyEditingReducer = require('./../element/selection/currentlyEditingReducer');

var _currentlyEditingReducer2 = _interopRequireDefault(_currentlyEditingReducer);

var _selectionReducer = require('./../element/selection/selectionReducer');

var _selectionReducer2 = _interopRequireDefault(_selectionReducer);

var _gridReducer = require('../utils/grid/gridReducer');

var _gridReducer2 = _interopRequireDefault(_gridReducer);

var _currentUserReducer = require('../user/currentUserReducer');

var _currentUserReducer2 = _interopRequireDefault(_currentUserReducer);

var _draggingReducer = require('./draggingReducer');

var _draggingReducer2 = _interopRequireDefault(_draggingReducer);

var _progressiveImageReducer = require('../components/images/progressiveImages/progressiveImageReducer');

var _progressiveImageReducer2 = _interopRequireDefault(_progressiveImageReducer);

var _popupReducer = require('../components/popupPanel/popupReducer');

var _popupReducer2 = _interopRequireDefault(_popupReducer);

var _modalReducer = require('../components/modal/modalReducer');

var _modalReducer2 = _interopRequireDefault(_modalReducer);

var _socketReducer = require('../utils/socket/socketReducer');

var _socketReducer2 = _interopRequireDefault(_socketReducer);

var _staticResourcesReducer = require('../components/static/staticResourcesReducer');

var _staticResourcesReducer2 = _interopRequireDefault(_staticResourcesReducer);

var _currentBoardIdReducer = require('./currentBoardId/currentBoardIdReducer');

var _currentBoardIdReducer2 = _interopRequireDefault(_currentBoardIdReducer);

var _dragModifierKeysReducer = require('../utils/dnd/modifierKeys/dragModifierKeysReducer');

var _dragModifierKeysReducer2 = _interopRequireDefault(_dragModifierKeysReducer);

var _analyticsReducer = require('../analytics/analyticsReducer');

var _analyticsReducer2 = _interopRequireDefault(_analyticsReducer);

var _richMediaReducer = require('../element/richMedia/richMediaReducer');

var _richMediaReducer2 = _interopRequireDefault(_richMediaReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Client only state
var reducersMap = {
    currentBoardId: _currentBoardIdReducer2.default,
    currentlyEditing: _currentlyEditingReducer2.default,
    dragModifierKeys: _dragModifierKeysReducer2.default,
    selection: _selectionReducer2.default,
    gridSize: _gridReducer2.default,
    currentUser: _currentUserReducer2.default,
    dragging: _draggingReducer2.default,
    progressiveImages: _progressiveImageReducer2.default,
    socketConnection: _socketReducer2.default,
    popup: _popupReducer2.default,
    modal: _modalReducer2.default,
    staticResources: _staticResourcesReducer2.default,
    analytics: _analyticsReducer2.default,
    richMedia: _richMediaReducer2.default
};

// only include the electron-specific reducer when running in electron context
if (process.env.APPLICATION_MODE === 'electron') {
    reducersMap.electron = require('./electronReducer').default;
}

var appReducer = (0, _reduxImmutable.combineReducers)(reducersMap);

var clientAppReducer = function clientAppReducer(state, action) {
    if (action.remote) {
        return state;
    }
    return appReducer(state, action);
};

exports.default = clientAppReducer;


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/appReducer.js
// module id = 2038
// module chunks = 0